import React, { useState, FC, useMemo, useEffect } from "react";
import { IAvailableSlot, IReservedSlot, IWorkingHours, DisplayMode } from "./helper";
import { Moment } from "moment";
import UpdateButton from "./UpdateButton";
import AvailabilityRow from "./AvailablilityRow";
import moment from "moment";
import { getDatesArray } from './helper';

interface Props {
  datesArray?: Moment[];
  availabilityView?: boolean;
  selectedHours: IWorkingHours;
  defaultSlots: Array<IAvailableSlot>;
  reservedSlots: Array<IReservedSlot>;
  selectedMonth: number;
  selectedYear?: number;
  onUpdate?: (slots: Array<IAvailableSlot>) => void;
  // Reports the grid's current (possibly unsaved) slots so a parent can build on them.
  onSlotsChange?: (slots: Array<IAvailableSlot>) => void;
  onSelect?: (date: string, hour: number) => void;
  displayMode: DisplayMode;
}

const AvailabilityTable: FC<Props> = (props) => {
  const {
    selectedHours: { startTime, endTime },
    defaultSlots,
    onUpdate,
    onSlotsChange,
    onSelect,
    reservedSlots = [],
    selectedMonth,
    selectedYear = new Date().getFullYear(),
    displayMode,
    availabilityView,
  } = props;

  const [availableSlots, setAvailableSlots] = useState<Array<IAvailableSlot>>(defaultSlots);

  // Update internal state when defaultSlots change
  useEffect(() => {
    setAvailableSlots(defaultSlots);
  }, [defaultSlots]);

  useEffect(() => {
    onSlotsChange?.(availableSlots);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableSlots]);

  const monthNumber = selectedMonth + 1; // JS months are 0-based, your slots are 1-based
  const allSlotDates = Array.from(new Set([
    ...availableSlots.map(slot => slot.date),
    ...reservedSlots.map(slot => slot.date)
  ])).filter(date => {
    // date is in "MM-DD" format
    const [mm] = date.split("-");
    return parseInt(mm, 10) === monthNumber;
  });
  const datesArray = getDatesArray(selectedMonth, displayMode, selectedYear);

  const filteredReservedSlots = reservedSlots.filter(slot => {
    const [mm] = slot.date.split("-");
    return parseInt(mm, 10) === monthNumber;
  });

  const updateAvailabilitySlots = (date: string, hour: number) => {
    const slots = [...availableSlots];
    const existingDate = slots.find((e) => e.date === date);
    if (existingDate) {
      const hourIndex = existingDate.time.findIndex((e) => e === hour);
      if (hourIndex === -1) existingDate.time.push(hour);
      else {
        existingDate.time.splice(hourIndex, 1);
        if (!existingDate.time.length) {
          const dateIndex = slots.findIndex((e) => e.date === date);
          slots.splice(dateIndex, 1);
        }
      }
    } else {
      slots.push({ date, time: [hour] });
    }
    setAvailableSlots(slots);
  };

  const clickCallback = useMemo(
    () => onSelect ?? updateAvailabilitySlots,
    [onSelect, availableSlots]
  );

  console.log("Rendering AvailabilityRow with availableSlots:", availableSlots);
  console.log("datesArray:", datesArray.map(d => d.format("MM-DD")));

  return (
    <>
      <div style={{ width: "100%", overflow: "auto" }}>
        <table className="calendar-table" style={{ width: "100%" }}>
          <thead>
            <tr>
              {/* <th>Time/Dates</th> */}
              {datesArray.map((date) => (
                <th
                  key={`${date.toISOString()}-date-head`}
                  style={{ minWidth: "100px" }}
                >
                  <div style={{ fontSize: '16px', fontWeight: 600 }}>{date.format("MMM DD")}</div>
                  <div style={{ marginTop: 4, fontSize: '14px', color: '#6b7280' }}>{date.format("ddd")}</div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {Array.from({ length: endTime - startTime }).map((_, i) => {
              return (
                <tr key={`table-${i}-row`}>
                  <AvailabilityRow
                    {...props}
                    availableSlots={availableSlots}
                    onClick={clickCallback}
                    hour={startTime + i}
                    datesArray={datesArray}
                    disableUnavailable={!!availabilityView}
                  />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {onUpdate && <UpdateButton onClick={() => onUpdate(availableSlots)} />}
    </>
  );
};

export default AvailabilityTable;